/* SAMPLE COLLECTORS */
export const GET_SHARED_PERCENTAGE_PENDING_FEE = "GET_SHARED_PERCENTAGE_PENDING_FEE";
export const GET_SHARED_PERCENTAGE_PENDING_FEE_SUCCESS =
  "GET_SHARED_PERCENTAGE_PENDING_FEE_SUCCESS";
export const GET_SHARED_PERCENTAGE_PENDING_FEE_FAIL = "GET_SHARED_PERCENTAGE_PENDING_FEE_FAIL";

export const GET_SHARED_PERCENTAGE_APPROVED_FEE = "GET_SHARED_PERCENTAGE_APPROVED_FEE";
export const GET_SHARED_PERCENTAGE_APPROVED_FEE_SUCCESS =
  "GET_SHARED_PERCENTAGE_APPROVED_FEE_SUCCESS";
export const GET_SHARED_PERCENTAGE_APPROVED_FEE_FAIL = "GET_SHARED_PERCENTAGE_APPROVED_FEE_FAIL";

export const UPDATE_SHARED_PERCENTAGE_PENDING_FEE = "UPDATE_SHARED_PERCENTAGE_PENDING_FEE";
export const UPDATE_SHARED_PERCENTAGE_PENDING_FEE_SUCCESS =
  "UPDATE_SHARED_PERCENTAGE_PENDING_FEE_SUCCESS";
export const UPDATE_SHARED_PERCENTAGE_PENDING_FEE_FAIL =
  "UPDATE_SHARED_PERCENTAGE_PENDING_FEE_FAIL";

export const UPDATE_SHARED_PERCENTAGE_ALL_PENDING_FEE = "UPDATE_SHARED_PERCENTAGE_ALL_PENDING_FEE";
export const UPDATE_SHARED_PERCENTAGE_ALL_PENDING_FEE_SUCCESS =
  "UPDATE_SHARED_PERCENTAGE_ALL_PENDING_FEE_SUCCESS";
export const UPDATE_SHARED_PERCENTAGE_ALL_PENDING_FEE_FAIL =
  "UPDATE_SHARED_PERCENTAGE_ALL_PENDING_FEE_FAIL";
